<template>
  <div>
    <section>
      <div class="row menu-content" v-if="menu.SpecialCategories">
        <div v-for="product in validProducts" :key="product.ID" class="col-sm-12 col-md-6 col-xl-4">
          <gift-product
            :product="menu.Products[product.ProductID]"
            :category="product"
            :key="product.ID"
          />
        </div>
      </div>
      <div v-else>
        <message />
      </div>
    </section>
  </div>
</template>

<script>
import GiftProduct from "./GiftProduct";

import Message from "../../shared/Message";
export default {
  name: "ProductList",
  components: { GiftProduct, Message },
  props: {
    menu: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    validProducts() {
      let temp = [];
      this.menu.SpecialCategories.SCTypeGiftcard.SubMenuItems.forEach(
        (element) => {
          if (this.menu.Products[element.ProductID]) {
            temp.push(element);
          }
        }
      );
      return temp;
    },
  },
};
</script>
